export default __webpack_public_path__ + "static/media/banned.6513a574.png";